module.exports = __webpack_public_path__ + "media/images/icons/closed_eye-0d1db573e7e15697856c87b55dc63422.svg";